/* eslint-disable no-restricted-globals */
import axios from "axios";
import store from "../store";
import { clearAuth } from "../store/slice/auth";

const unauthorizedCode = [401];

const baseURL =
  process.env.NODE_ENV === "production"
    ? "https://argetam-api.xitehub.com/api/v1"
    : "https://argetam-api.xitehub.com/api/v1";

export const axiosInstance = axios.create({
  timeout: 60000,
  baseURL: baseURL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    let accessToken;

    if (!accessToken) {
      const { auth } = store.getState();
      accessToken = auth.token;
    }

    let currency = store.getState().config.currency || "USD";
    let language = store.getState().config.language || "en";
    let country = store.getState().config.countryCode || "us";

    if (config.method === "post") {
      config.params = { ...config.params, currency, language, country };
    } else {
      config.params = { ...config.params, currency, language, country };
    }

    if (accessToken) {
      config.headers.Authorization = accessToken;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    if (response && unauthorizedCode.includes(response.status)) {
      store.dispatch(clearAuth());
      location.replace("/");
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
